import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=85b13cdc&scoped=true"
import script from "./MenuComponent.js?vue&type=script&lang=js&external"
export * from "./MenuComponent.js?vue&type=script&lang=js&external"
import style0 from "./MenuComponent.vue?vue&type=style&index=0&id=85b13cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b13cdc",
  null
  
)

export default component.exports